import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { redirect, useParams, useRouteLoaderData } from 'react-router-dom';
import { toast } from 'react-toastify';
import { approveArtwork, approveArtworkMadeByLP, getProjectItemDetails, rejectAndRequestChange, rejectArtworkMadeByLP, requestSampleArtwork } from '../../api/project';
import { Steps } from '../../components/Steps';
import { ProjectItem } from '../../components/project';
import i18n from '../../i18n.js';
import { generateRouteUrl, ItemClientStatuses } from '../../library/constants';
import style from './client-artwork.module.scss';
import { StepBody } from './index';

const Dashboard = () => {
    const { quotationToken } = useParams()
    const { projectItems } = useRouteLoaderData('DashboardRoot') ?? {}
    const { t } = useTranslation();



    return (
        <div className="wrapper dashboard-wrapper">
            <div className="main">
                {projectItems && projectItems.map((item, index) => (
                    <div key={item.id ?? index} className={style.mergedWrapper}>
                        <ProjectItem item={item} numbering={index + 1} totalItems={projectItems.length} quotationToken={quotationToken} />
                        <div className={style.stepBar} style={{ paddingBottom: '15px' }}>
                            <Steps
                                current_step={item.client_status}
                                stateChanger={() => { }}
                                items={[
                                    {
                                        title: t('Upload Artwork'),
                                        icon: <img src="/icons/timeline/upload-artwork.svg" alt='upload artwork' />,
                                        index: ItemClientStatuses.ORDER_CONFIRMATION,
                                    },
                                    {
                                        title: t('Artwork in review'),
                                        icon: <img src="/icons/timeline/artwork-in-review.svg" alt='artwork in review' />,
                                        index: ItemClientStatuses.UPLOAD_ARTWORK,
                                    },
                                    {
                                        title: t('Final Approval'),
                                        icon: <img src='/icons/timeline/final-approval.svg' alt='final approval' />,
                                        index: ItemClientStatuses.FINAL_APPROVAL,
                                    },
                                    {
                                        title: t('In Production'),
                                        icon: <img src='/icons/timeline/in-production.svg' alt='in production' />,
                                        index: ItemClientStatuses.IN_PRODUCTION,
                                    },
                                    {
                                        title: t('In Transit '),
                                        icon: <img src='/icons/timeline/in-transit.svg' alt='In Transit' />,
                                        index: ItemClientStatuses.IN_TRANSIT,
                                    },
                                    {
                                        title: t('Delivered'),
                                        icon: <img src='/icons/timeline/delivered.svg' alt='Delivered' />,
                                        index: ItemClientStatuses.DELIVERED,
                                    },
                                ]}
                            />
                            <h2 style={{ fontSize: '1.25rem', fontWeight: '500', color: '#333', textAlign: 'left', padding: '0 20px', margin: '15px 0 0 0' }}>
                                {t('Your Tasks')}
                            </h2>
                        </div>
                        <StepBody 
                            data={item} 
                            quotationToken={quotationToken} 
                            stateChanger={() => { }} 
                            style={{ 
                                borderTopLeftRadius: 0, 
                                borderTopRightRadius: 0, 
                                borderBottomLeftRadius: 'var(--radius-large)', 
                                borderBottomRightRadius: 'var(--radius-large)', 
                                boxShadow: 'none', 
                                borderTop: 'none', 
                                marginTop: 0 
                            }} 
                        />
                    </div>
                ))}
            </div>
        </div >
    )
}

Dashboard.Actions = {
    requestartworksample: async ({ params, data }) => {
        const { quotationToken } = params
        const { itemId } = data
        try {
            const msg = await requestSampleArtwork(quotationToken, itemId)
            console.log(msg);

            toast.success(i18n.t(msg))
            return redirect(generateRouteUrl('Dashboard', { quotationToken }))
        } catch (e) {
            toast.error(i18n.t(e?.message))
        }

    },

    approveProof: async ({ params, data }) => {
        const { quotationToken } = params
        const { itemId } = data
        try {
            const msg = await approveArtwork(quotationToken, itemId)
            toast.success(i18n.t(msg))
            const projectItem = await getProjectItemDetails(quotationToken, itemId)
            if (!projectItem.client_confirm_address) {
                return redirect(generateRouteUrl('ProjectItemAddress', {
                    quotationToken,
                    itemId
                }))
            }
            return redirect(generateRouteUrl('Dashboard', { quotationToken }))
        }
        catch (e) {
            toast.error(i18n.t(e?.message))
        }
    },
    rejectProof: async ({ params, data }) => {
        const { quotationToken } = params
        const { itemId, comment } = data
        try {
            const msg = await rejectAndRequestChange(quotationToken, itemId, { comment })
            toast.success(i18n.t(msg))
            return redirect(generateRouteUrl('Dashboard', { quotationToken }))
        }
        catch (e) {
            toast.error(i18n.t(e?.message))

        }
    },

    approveMakeArtwork:
        async ({ params, data }) => {
            const { quotationToken } = params
            const { itemId } = data
            try {
                const msg = await approveArtworkMadeByLP(quotationToken, itemId)
                toast.success(i18n.t(msg))
                return redirect(generateRouteUrl('Dashboard', { quotationToken }))
            }
            catch (e) {
                toast.error(i18n.t(e?.message))
            }
        },

    rejectMakeArtwork: async ({ params, data }) => {
        const { quotationToken } = params
        const { itemId, rejectComment } = data
        try {
            const msg = await rejectArtworkMadeByLP(quotationToken, itemId, { comment: rejectComment })
            toast.success(i18n.t(msg))
            return redirect(generateRouteUrl('Dashboard', { quotationToken }))
        }
        catch (e) {
            toast.error(i18n.t(e?.message))

        }
    },



}

function ScrollBottomDetector({ onBottom }) {
    useEffect(() => {
        let timeout;

        const handleScroll = () => {
            if (timeout) return;

            timeout = setTimeout(() => {
                const scrollTop = window.scrollY || document.documentElement.scrollTop;
                const documentHeight = document.documentElement.scrollHeight;
                const viewportHeight = window.innerHeight;

                if (scrollTop + viewportHeight + 50 >= documentHeight) {
                    onBottom(true);
                } else {
                    onBottom(false);
                }

                timeout = null; // Reset throttle
            }, 200); // Adjust throttle delay as needed
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [onBottom]);

    return null;
};


// Dashboard.Loader = async ({ params }) => {
//     const { quotationToken } = params
//     const { items } = await getProjectDetails(quotationToken)
//     const projectItems = await Promise.all(items.map(({ id }) => getProjectItemDetails(quotationToken, id)))
//     const projectDocs = await Promise.all(items.map(({ id }) => getDocuments(quotationToken, id)))
//     const projectItemDetails = projectItems.map(item => ({
//         documents: projectDocs.find(({ id }) => item.id === id),
//         ...item,
//     }))

//     return {
//         projectItems: projectItemDetails,
//     }
// }

export default Dashboard
/* 
<Steps steps={[
    {
        name: "uploadartwork",
        icon: "/icons/steps/image.svg",
        label: "Upload Artwork"
    },
    {
        name: "uploadartwork1",
        icon: "/icons/steps/image2.svg",
        label: "Upload Artwork"
    },
    {
        name: "upload3",
        icon: "/icons/steps/image2.svg",
        label: "Upload Artwork"
    },
    {
        name: "upload4",
        icon: "/icons/steps/image2.svg",
        label: "Upload Artwork"
    },
    {
        name: "upload6",
        icon: "/icons/steps/image2.svg",
        label: "Upload Artwork"
    },
]} /> */
